import { Navigate, useParams } from 'react-router-dom';

import { insightsHubCategoriesConfig } from './constants';

/**
 * Legacy category URLs land on search with the query prefilled, which is the
 * same thing a suggestion pill does. There are no category listing pages any
 * more: the category name is indexed on every document in the group, so a plain
 * text search for the label returns the whole category.
 *
 * Kept as a route because old links and bookmarks still point here, and because
 * ':category/:slug' below it is the article detail page.
 */
export const CategoryRedirect = () => {
  const { category } = useParams();
  const config = insightsHubCategoriesConfig.find(
    // Accept the website's hyphenated slug too, so a link copied between the
    // two surfaces resolves instead of silently falling back to the hub.
    ({ key }) => key === category || key.replace(/_/g, '-') === category
  );

  if (!config || config.key === 'all') {
    return <Navigate to='/research-hub' replace />;
  }

  return <Navigate to={`/research-hub/search?q=${encodeURIComponent(config.label)}`} replace />;
};
